import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { Trip } from '../../entities';
import { RelativeTimePipe } from '../../../shared/pipes';
import { RouterLink } from '@angular/router';
import { PhotosApi } from '@at/photos';
import { toSignal } from '@angular/core/rxjs-interop';
import { UserService } from '@at/user';

@Component({
  selector: 'at-trip-card',
  standalone: true,
  imports: [RelativeTimePipe, RouterLink],
  templateUrl: './trip-card.component.html',
  styleUrl: './trip-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'aria-atomic': 'true',
    '[style.--bg-img]': 'image()',
  },
})
export class TripCardComponent {
  #photosApi = inject(PhotosApi);
  #user = toSignal(inject(UserService).user$);

  public trip = input.required<Trip>();
  public showOwner = input<boolean>(true);
  protected readonly isOwner = computed(() => {
    const trip = this.trip;
    const user = this.#user();

    return user ? trip().owner === user.userId : false;
  });

  protected readonly tripDescription = computed(() => {
    const trip = this.trip();

    if (!trip) return '';
    return trip.description;
  });

  protected readonly image = computed(() =>
    this.trip().tripCover ? `url(${this.trip().tripCover})` : 'none',
  );
}
